module.exports = __webpack_public_path__ + "img/hr-long-handed-inserter-platform.e9d365b3.png";